import { Component } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { StudentService } from 'src/app/private/services/student.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { AcademicYearService } from 'src/app/private/services/acedemicyear.service';
import { CourseService } from 'src/app/private/services/course.service';
import { BatchService } from 'src/app/private/services/batch.service';
import { UploadService } from 'src/app/private/services/upload.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { StudentProfileMiddleScreenComponent } from '../student-profile-middle-screen/student-profile-middle-screen.component';
import { FeeService } from 'src/app/private/services/fee-service.service';
import { TransportService } from 'src/app/private/services/transport.service';
import { ScholarshipService } from 'src/app/private/services/scholarship.service';
import { HostelService } from 'src/app/private/services/hostel.service';

@Component({
  selector: 'app-student-profile',
  standalone: true,
  imports: [SharedModule, StudentProfileMiddleScreenComponent],
  templateUrl: './student-profile.component.html',
  styleUrl: './student-profile.component.scss'
})
export class StudentProfileComponent {

  selectedTabIdx = 0;
  student_id: any = '';
  initialLoading = true;
  studentDetails: any = {};
  users: any = [];

  selectedStatus = '';
  selectedAcademicYear = '';
  selectedCourse = '';
  selectedBatch = '';
  loading = false;
  previewImage: string | null = null;

  studentStatusList: any[] = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
    { value: 'Graduated', label: 'Graduated' },
    { value: 'Suspended', label: 'Suspended' },
    { value: 'Withdrawn', label: 'Withdrawn' }
  ];

  selectedFeeCategory = '';
  selectedDepartment = '';

  selectedHostelCategory = '';
  selectedScholarshipType = '';
  selectedTransportRoute = '';

  allCourses: any[] = [];
  batchList: any[] = [];
  academicYearList: any[] = [];
  feeCategoryList: any[] = [];
  departmentList: any[] = [];

  hostelCategoryList: any[] = [];
  scholarshipTypeList: any[] = [];
  transportRouteList: any[] = [];

  constructor(
    private messageService: MessageService,
    private location: Location,
    private route: ActivatedRoute,
    private api: StudentService,
    private localStorage: LocalStorageService,
    private userApi: UsersService,
    private academicYearApi: AcademicYearService,
    private batchApi: BatchService,
    private courseApi: CourseService,
    private uploadService: UploadService,
    private feeGroupApi: FeeService,
    private hostelApi: HostelService,
    private scholarshipApi: ScholarshipService,
    private transportApi: TransportService
  ) {
    this.student_id = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.getStudentDetails();
    this.getAllUsers();
    this.getAllCourses();
    this.getAllAcademicYears();
    this.getAllBatches();
    this.getAllFeeCategories();
    this.getAllDepartments();
    this.getAllHostelCategories();
    this.getAllScholoarshipTypes();
    this.getAllTransportRoutes();
  }

  getStudentDetails() {
    if (!this.student_id) return;

    this.api.getStudentById(this.student_id).subscribe({
      next: (res: any) => {
        this.studentDetails = res || {};
        this.selectedStatus = this.studentDetails.status;
        this.selectedAcademicYear = this.studentDetails.academic_year;
        this.selectedCourse = this.studentDetails.course_id;
        this.selectedBatch = this.studentDetails.batch_id;
        this.selectedFeeCategory = this.studentDetails.fee_group_id;
        this.selectedDepartment = this.studentDetails.department_id;
        this.selectedHostelCategory = this.studentDetails.hostel_category;
        this.selectedScholarshipType = this.studentDetails.scholarship_id;
        this.selectedTransportRoute = this.studentDetails.transport_category;
        this.initialLoading = false;

        console.log('Student Details:', this.studentDetails);
        this.loading = false;
      },
      error: (err: any) => {
        this.initialLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.message || 'Failed to load student details'
        });
      }
    });
  }

  getAllDepartments() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.userApi.getAllDepartment(param).subscribe({
      next: (data) => {
        this.departmentList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }


  getAllUsers() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  getAllCourses() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.courseApi.getAllCourses(param).subscribe({
      next: (data) => {
        this.allCourses = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllAcademicYears() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.academicYearApi.getAllAcademicYears(param).subscribe({
      next: (data) => {
        this.academicYearList = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllFeeCategories() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.feeGroupApi.getAllActiveFeeGroups(param).subscribe({
      next: (data) => {
        this.feeCategoryList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllBatches() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.batchApi.getAllBatches(param).subscribe({
      next: (data) => {
        this.batchList = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getFullName() {
    return [this.studentDetails?.prefix, this.studentDetails?.first_name, this.studentDetails?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  handleCopy() {
    console.log('Copied');
    let email = this.studentDetails.email;
    navigator.clipboard.writeText(email);
    this.messageService.add({ severity: 'success', summary: 'Email copied', detail: 'Email copied to clipboard' });
  }


  getInitials() {
    const firstName = this.studentDetails?.first_name || '';
    const lastName = this.studentDetails?.last_name || '';
    return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
  }

  updateStudentField(field: string) {
    let updateData: any = {
      student_id: this.student_id,
      organization_id: this.localStorage.getOrganizationId()
    };

    switch (field) {
      case 'status':
        updateData.status = this.selectedStatus;
        break;
      case 'academic_year':
        updateData.academic_year = this.selectedAcademicYear;
        break;
      case 'course':
        updateData.course_id = this.selectedCourse;
        break;
      case 'batch':
        updateData.batch_id = this.selectedBatch;
        break;
    }

    this.api.updateStudent(updateData).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Student updated successfully'
        });
      },
      error: (err: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.message || 'Failed to update student'
        });
      }
    });
  }

  async onProfileImageUpload(event: Event): Promise<any> {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files[0]) {
      const file = input.files[0];

      // Show image immediately using FileReader
      const reader = new FileReader();

      reader.onload = async (e: ProgressEvent<FileReader>) => {
        const result = e.target?.result;
        if (typeof result === 'string') {
          this.previewImage = result;

          this.messageService.add({
            severity: 'info',
            summary: 'Info',
            detail: 'Uploading Image...',
          });

          try {

            const imageUrl = await this.uploadToS3(file);

            const payload = {
              ...this.studentDetails,
              photo_url: imageUrl,
              // lead_id: this.lead_id,
              user_id: this.localStorage.getUserId(),
              // old_admission_data: this.admissionDetails,
            };

            this.api.updateStudent(payload).subscribe({
              next: (response) => {
                console.log('Profile Image Updated:', response);
                this.messageService.clear();
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: 'Profile Image Updated Successfully'
                });
              },
              error: (error) => {
                console.error('Error:', error);
                this.messageService.clear('upload');
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'Something went wrong'
                });
              }
            });
          } catch (error) {
            console.error('Upload failed:', error);
            this.messageService.clear('upload');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to upload image.'
            });
          }
        }
      };

      reader.readAsDataURL(file);
    }
  }


  async uploadToS3(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      const folder = `education/students/documents`;
      formData.append('file', file);
      formData.append('folders', folder);
      formData.append('bucket', 'global-upload-storage');

      this.uploadService.uploadDocuments(formData).subscribe({
        next: (response: any) => {
          console.log('File uploaded successfully:', response);
          resolve(response.url); // Assuming API returns { url: 's3-url' }
        },
        error: (error) => {
          console.error('Error uploading file:', error);
          reject('');
        },
      });
    });
  }

  updateStudentProfileImage(imageUrl: string) {
    const updateData = {
      student_id: this.student_id,
      organization_id: this.localStorage.getOrganizationId(),
      profile_pic: imageUrl
    };

    this.api.updateStudent(updateData).subscribe({
      next: (res: any) => {
        this.studentDetails.profile_pic = imageUrl;
        this.previewImage = null;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Profile image updated successfully'
        });
      },
      error: (err: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update profile image'
        });
      }
    });
  }

  handleCall() {
    // Implement call functionality
    console.log('Call student:', this.studentDetails);
  }

  handleWhatsapp() {
    // Implement WhatsApp functionality
    console.log('WhatsApp student:', this.studentDetails);
  }

  handleEmail() {
    // Implement email functionality
    console.log('Email student:', this.studentDetails);
  }

  handleBack() {
    console.log('Back');
    this.location.back();
  }


  handleSaveQuickActions() {

    const payload: any = {
      ...this.studentDetails,
      old_student_details: this.studentDetails,
      course_id: this.selectedCourse,
      academic_year_id: this.selectedAcademicYear,
      batch_id: this.selectedBatch,
      fee_group_id: this.selectedFeeCategory,
      user_id: this.localStorage.getUserId()
    };

    this.loading = true;
    this.api.updateStudent(payload).subscribe({
      next: (response) => {
        console.log('Update Student:', response);
        this.getStudentDetails();
      },
      error: (error) => {
        this.loading = false;
        console.log('Error:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
      }
    });

  }


  getAllHostelCategories() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.hostelApi.getAllHostelCategories(param).subscribe({
      next: (data) => {
        this.hostelCategoryList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllScholoarshipTypes() {

    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.scholarshipApi.getAllScholarships(param).subscribe({
      next: (data) => {
        this.scholarshipTypeList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllTransportRoutes() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.transportApi.getAllTransports(param).subscribe({
      next: (data) => {
        this.transportRouteList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }


}
